import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NotifiedReferrersDropdownModal from "@Broker/@HandlebarsTemplates/clients/board/_notified-referrers-dropdown.hbs";
import { mapActions } from "vuex";
import Err from "../../../../../routes/error";
import { LOAD_CLIENT_PROFILE_SUBSCRIBERS, SUBSCRIBE_REFERRER, UNSUBSCRIBE_REFERRER } from "@Broker/@Modules/clients/board/store/board-actions";
import CollapsibleCard from "@Broker/@Modules/clients/board/client-profile/components/shared/collapsible-card.vue";
import ServerSideReferrersSelect from "@Broker/@Modules/clients/referrers/components/server-side-referrers-select.vue";
import ClientProfileDetailsLoader from "@Broker/@Modules/clients/board/client-profile/components/client-profile-details-loader.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "NotifiedReferrers",
  components: {
    ServerSideReferrersSelect,
    CollapsibleCard,
    ClientProfileDetailsLoader
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    profile: {
      type: Object,
      required: true
    },
    referrers: {
      type: Array,
      required: true
    },
    collapse: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      allReferrers: [],
      notifiedReferrers: []
    };
  },
  computed: {
    computedReferrers() {
      var _context;
      return _filterInstanceProperty(_context = this.referrers).call(_context, ({
        email
      }) => email);
    }
  },
  watch: {
    computedReferrers(val) {
      if (val && val.length) {
        this.allReferrers = val;
      }
    }
  },
  mounted() {
    this.updateNotifiedReferrers();
  },
  activated() {
    // this is needed because on deactivated, the dropdownParent is removed from DOM
    // which breaks entirely the select2
    this.updateNotifiedReferrers();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_CLIENT_PROFILE_SUBSCRIBERS, SUBSCRIBE_REFERRER, UNSUBSCRIBE_REFERRER])), {}, {
    formatData(data) {
      return data && _mapInstanceProperty(data).call(data, ref => {
        ref.text = `${ref.givenName} ${ref.familyName}`;
        return ref;
      });
    },
    handleSelect2Click(event) {
      var _context2;
      if (_includesInstanceProperty(_context2 = ["no-results-span", "no-results-btn"]).call(_context2, event.target.id)) {
        const text = $("#notified-referrers-select-container .select2-search__field").val();
        $("#notified-referrers-select").select2("close");
        const [givenName = "", ...familyNames] = text.split(" ");
        const familyName = familyNames.join(" ");
        this.$emit("handle-referrer", null, {
          givenName,
          familyName
        }, "notified");
      }
    },
    options() {
      const formatResult = state => $(NotifiedReferrersDropdownModal(state));
      const createAsNewReferrer = this.$t("referrers.actions.createAsNewReferrer");
      return {
        templateResult: formatResult,
        dropdownParent: "#notified-referrers-select-container",
        allowClear: false,
        closeOnSelect: false,
        dropdownCssClass: "referrers-select",
        language: {
          noResults() {
            const text = $("#notified-referrers-select-container .select2-search__field").val();
            return `
              <button class="no-results-btn d-flex flex-column bold" id="no-results-btn"> ${text}
                <span class="grey-text font-italic font-weight-normal" id="no-results-span" style="pointer-events: none;">
                  ${createAsNewReferrer}
                </span>
              </button>`;
          }
        },
        escapeMarkup(markup) {
          return markup;
        }
      };
    },
    async subscribeReferrer(referrer) {
      try {
        const subscription = {
          subscriberId: referrer.id,
          subscriberOptions: {
            statusChange: true
          }
        };
        await this.SUBSCRIBE_REFERRER({
          id: this.clientProfileId,
          subscribers: [subscription],
          referrers: [referrer]
        });
        this.$emit("change-referrer");
      } catch (error) {
        var _context3, _context4;
        _spliceInstanceProperty(_context3 = this.notifiedReferrers).call(_context3, _findIndexInstanceProperty(_context4 = this.notifiedReferrers).call(_context4, ({
          id
        }) => id === referrer.id), 1);
        this.$refs["referrersSelect"].setSelectedData();
      }
    },
    async unsubscribeReferrer(referrer) {
      try {
        await this.UNSUBSCRIBE_REFERRER({
          id: this.clientProfileId,
          referrerId: referrer.id
        });
        this.$emit("change-referrer");
      } catch (error) {
        Err.handle(error);
      }
    },
    async toggleReferrerSubscription({
      referrer,
      type
    }) {
      switch (type) {
        case "unselect":
          return this.unsubscribeReferrer(referrer);
        case "select":
          return this.subscribeReferrer(referrer);
      }
    },
    async updateNotifiedReferrers() {
      await this.LOAD_CLIENT_PROFILE_SUBSCRIBERS(this);
      this.$nextTick(() => {
        if (this.profile.notifiedReferrers) {
          var _context5, _this$profile$notifie;
          this.notifiedReferrers = _mapInstanceProperty(_context5 = _Object$values((_this$profile$notifie = this.profile.notifiedReferrers) == null ? void 0 : _this$profile$notifie.byId)).call(_context5, referrer => _objectSpread(_objectSpread({}, referrer), {}, {
            id: referrer.subscriberId
          })) || [];
        }
      });
    },
    handleReferrer({
      referrerId,
      referrerData
    }) {
      this.$emit("handle-referrer", referrerId, referrerData, "notified");
    }
  })
});